import { render, staticRenderFns } from "./PaymentsArchive.vue?vue&type=template&id=82da9b6a&scoped=true&"
import script from "./PaymentsArchive.vue?vue&type=script&lang=js&"
export * from "./PaymentsArchive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82da9b6a",
  null
  
)

export default component.exports